import { type components } from '~/fecom-api/schema';
import { Star } from './star';
import { Progress } from '../ui/progress';
import { ProductDetailsStarRating } from './product-details-star-rating';

type ProductDetailsReviewSummaryProps = {
  summary: components['schemas']['ProductReviewSummary'];
};

export function ProductDetailsReviewSummary({
  summary,
}: ProductDetailsReviewSummaryProps) {
  return (
    <div className="m-auto flex max-w-lg flex-row justify-center gap-4 px-4">
      <div className="flex basis-1/3 flex-col items-center justify-center gap-2">
        <span className="text-2xl font-semibold">
          {summary.starsAverage} / 5
        </span>
        <ProductDetailsStarRating
          maxRating={5}
          rating={summary.starsAverage}
          hideText
        />
      </div>
      <div className="grid grow grid-cols-[max-content_max-content_1fr_max-content] flex-col gap-1">
        <RatingRow
          label={'5'}
          value={summary.numberOfReviews.fiveStars}
          total={summary.numberOfReviews.total}
        />
        <RatingRow
          label={'4'}
          value={summary.numberOfReviews.fourStars}
          total={summary.numberOfReviews.total}
        />
        <RatingRow
          label={'3'}
          value={summary.numberOfReviews.threeStars}
          total={summary.numberOfReviews.total}
        />
        <RatingRow
          label={'2'}
          value={summary.numberOfReviews.twoStars}
          total={summary.numberOfReviews.total}
        />
        <RatingRow
          label={'1'}
          value={summary.numberOfReviews.oneStar}
          total={summary.numberOfReviews.total}
        />
      </div>
    </div>
  );
}
type RatingRowProps = {
  label: string;
  value: number;
  total: number;
};
const RatingRow = ({ label, total, value }: RatingRowProps) => {
  return (
    <div className="col-span-4 grid grid-cols-subgrid items-center gap-2">
      <span className="col-span-1 col-start-1 text-center text-sm font-semibold">
        {label}
      </span>
      <div className="col-span-1 col-start-2 text-center">
        <Star className="fill-primary" width={20} height={20} />
      </div>
      <div className="col-span-1 col-start-3 grow text-center">
        <Progress
          value={(value / total) * 100}
          className="rounded-full bg-neutral-200"
        />
      </div>
      <div className="col-span-1 col-start-4 text-center">{value}</div>
    </div>
  );
};
